import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { TabBar } from "../components/TabBar";
import { api } from "../api/client";
import type { WorkoutTemplate } from "../api/types";

export const Templates = () => {
  const [items, setItems] = useState<WorkoutTemplate[]>([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = async () => {
    setLoading(true);
    const data = await api<WorkoutTemplate[]>("/templates");
    setItems(data);
    setLoading(false);
  };

  useEffect(() => {
    void load();
  }, []);

  const create = async () => {
    const t = await api<WorkoutTemplate>("/templates", {
      method: "POST",
      body: { name: "New plan", exercises: [] },
    });
    nav(`/templates/${t.id}`);
  };

  const duplicate = async (id: string) => {
    await api(`/templates/${id}/duplicate`, { method: "POST" });
    await load();
  };

  const remove = async (id: string) => {
    if (!confirm("Delete this plan?")) return;
    await api(`/templates/${id}`, { method: "DELETE" });
    await load();
  };

  return (
    <>
      <div className="page">
        <h1 className="h1">Workout plans</h1>
        <div className="muted">Build reusable routines outside the gym.</div>
        <button className="btn" style={{ marginTop: 12 }} onClick={() => void create()}>
          + New plan
        </button>

        <div className="col" style={{ marginTop: 16 }}>
          {loading && <div className="muted">Loading…</div>}
          {!loading && items.length === 0 && (
            <div className="muted">No plans yet. Build your first one above.</div>
          )}
          {items.map((t) => (
            <div className="card" key={t.id}>
              <div className="row">
                <Link to={`/templates/${t.id}`} style={{ color: "inherit", flex: 1 }}>
                  <div style={{ fontWeight: 700 }}>{t.name}</div>
                  <div className="muted">{t.exercises.length} exercises</div>
                </Link>
                <button className="btn small secondary" onClick={() => void duplicate(t.id)}>
                  Copy
                </button>
                <button className="btn small secondary" onClick={() => void remove(t.id)}>
                  ✕
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <TabBar />
    </>
  );
};
